<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="30"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-0"
              >
                <v-icon size="30"> mdi-file-plus-outline </v-icon>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-1"
                @click="edit_dialog=true;getTransactionDetails(selectedRows[0].trans_type_id)"
              >
                <v-icon size="30"> mdi-clipboard-edit-outline </v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-1">
                <v-icon size="30"> mdi-eye-outline </v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
                class="ml-1"
              >
                <v-icon size="30"> mdi-delete-outline </v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="5">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setData({key : 'selected_alphabet',value : ''})" icon small dark v-bind="attrs" v-on="on" class="">
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="30">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-1">
                <v-icon>mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
           </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Transaction Types</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
          <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
        </v-overlay>
    <v-card flat tile>
      
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-row dense="" class="pa-0 ma-0">
          <v-col cols="1" class="pa-0 ma-0" style="max-width: 2.5%;">
            <AlphabetSort />
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-800"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4.5%">
                    <v-icon @click="editRecord(item.trans_type_id)">
                      mdi-clipboard-edit-outline
                    </v-icon>
                  </td>
                  <td width="4.5%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="32%">
                    {{item.title}}
                  </td>
                  <td width="17%">
                    <v-autocomplete
                      style="margin-top: -1px;"
                      :items="report_list"
                      dense=""
                      v-model="item.income_expence"
                      hide-details=""
                      @change="inlineUpdate(item)"
                    >
                    </v-autocomplete>
                  </td>
                  <td width="32%">
                    <!-- <v-autocomplete
                      style="margin-top: -1px;"
                      dense
                      hide-details
                      v-model="item.acc_type_id"
                      :items="account_type_list"
                      item-text="acc_type"
                      item-value="acc_type_id"
                      @change="inlineUpdate(item)"
                    >
                    </v-autocomplete> -->
                    <v-autocomplete
                      style="margin-top: -1px;"
                      dense
                      hide-details
                      v-model="item.bank_id"
                      :items="bank_list"
                      item-text="bank_name"
                      item-value="bank_id"
                      @change="inlineUpdate(item)"
                    >
                    </v-autocomplete>
                  </td>
                  <td width="9%" class="pl-4">
                    <v-switch
                      class="pt-0 ma-0"
                      v-model="item.profit_loss"
                      color="success"
                      hide-details
                      @change="inlineUpdate(item)"
                      dense
                    ></v-switch>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="350px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Transaction Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="form_data.income_expence"
                  :items="report_list"
                  label="Type"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-text-field
                  dense=""
                  label="Transaction Type*"
                  v-model="form_data.title"
                  :error-messages="form_error.title"
                  :hide-details="!form_error.title"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <!-- <v-autocomplete
                  dense
                  hide-details
                  v-model="form_data.acc_type_id"
                  :items="account_type_list"
                  item-text="acc_type"
                  item-value="acc_type_id"
                  label="Account Type"
                >
                </v-autocomplete> -->
                <v-autocomplete
                  dense
                  hide-details
                  v-model="form_data.bank_id"
                  :items="bank_list"
                  item-text="bank_name"
                  item-value="bank_id"
                  label="Chart Of Account"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-textarea
                  v-model="form_data.keywords"
                  label="Keywords (comma separated)"
                  dense
                  :error-messages="form_error.keywords"
                  :hide-details="!form_error.keywords"
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="form_data.profit_loss"
                  label="Profit & Loss"
                  color="success"
                  hide-details
                  class="mt-2"
                  dense
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {income_expence:'1', profit_loss: true};form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addTransactionType"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="350px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Transaction Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="edit_form_data.income_expence"
                  :items="report_list"
                  label="Type"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-text-field
                  dense=""
                  label="Transaction Type*"
                  v-model="edit_form_data.title"
                  :error-messages="edit_form_error.title"
                  :hide-details="!edit_form_error.title"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <!-- <v-autocomplete
                  dense
                  hide-details
                  v-model="edit_form_data.acc_type_id"
                  :items="account_type_list"
                  item-text="acc_type"
                  item-value="acc_type_id"
                  label="Account Type"
                >
                </v-autocomplete> -->
                <v-autocomplete
                  dense
                  hide-details
                  v-model="edit_form_data.bank_id"
                  :items="bank_list"
                  item-text="bank_name"
                  item-value="bank_id"
                  label="Chart Of Account"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-textarea
                  v-model="edit_form_data.new_keywords"
                  label="Keywords (comma separated)"
                  dense
                  :error-messages="edit_form_error.new_keywords"
                  :hide-details="!edit_form_error.new_keywords"
                  rows="1"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="22" v-bind="attrs" v-on="on" @click="keyword_dialog = true"> mdi-eye-outline </v-icon>
                      </template>
                      <span>View Exist Keyword</span>
                    </v-tooltip>
                  </template>
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="edit_form_data.profit_loss"
                  label="Profit & Loss"
                  color="success"
                  hide-details
                  class="mt-2"
                  dense
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error"
            @click="edit_dialog = false;edit_form_data = {profit_loss: true};edit_form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateTransactiontype" dark> Update </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmation </v-card-title>
        <v-card-text>
          Are you sure you want to delete selected transaction types?
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteTypes()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="keyword_dialog" max-width="350" persistent>
      <v-card
        class="mx-auto align-self-stretch"
        tile
        :loading="keyword_loading"
        width="100%"
      >
        <v-card-title class="headline pa-2">Keyword(s)</v-card-title>
        <v-card-text class="pa-2 pt-0" style="font-weight: 500;">
          <v-row dense v-if="edit_form_data.keywords && edit_form_data.keywords.length > 0" class="light-green lighten-4 primary--text">
            <v-col cols="12" class="pt-2" v-for="(keyword, index) in edit_form_data.keywords" :key="index">
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                width="22"
                height="22"
                color="primary"
                @click="deleteKeyword(keyword)"
              >
                <v-icon small>
                  mdi-close
                </v-icon>
              </v-btn>
              <span class="ml-2">{{ keyword.title }}</span>
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12">
              No Any Eixst Keyword!
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="keyword_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams } from "../../plugins/helper";
import AlphabetSort from "../AlphabetSort";
import { mapState,mapMutations } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      dialog: false,
      edit_dialog:false,
      delete_dialog: false,
      keyword_dialog: false,
      keyword_loading: false,
      form_data: {
        income_expence: '1',
        profit_loss: true
      },
      account_type_list: [],
      bank_list: [],
      form_error: {},
      edit_form_data: {profit_loss: true},
      edit_form_error: {},
      trans_type_id: null,
      search: "",
      form_loading:false,
      loading: false,
      items: {
        data: [],
      },
      headers: [
        { value: "", text: "", sortable: false, width: '4.5%' },
        { value: "checkbox", text: "", sortable: false, width:"4.5%" },
        { value: "tbl_trans_type.title", text: "Name", sortable: true, width:"32%" },
        { value: "tbl_trans_type.income_expence", text: "Type", sortable: true, width:"17%" },
        // { value: "AT.acc_type", text: "Account Type", sortable: true, width:"32%" },
        { value: "B.bank_name", text: "Chart Of Account", sortable: true, width:"32%" },
        { value: "profit_loss", text: "P&L", sortable: true, width:"9%", class:'pl-5' },
      ],
      report_list: [
        {text: 'Income', value: '1'},
        {text: 'Expense', value: '2'},
        {text: 'Assets', value: '3'},
        {text: 'Liability ', value: '4'},
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["title"],
        page: 1,
        filters: {
          alphabet: "",
        },
      },
      expanded: [],
      search_menu : false
    };
  },
  components: {
    AlphabetSort
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("submenu", ["selected_alphabet"]),
    selectedRows() {
      return this.items.data.filter(function (item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "title";
      return paginationData;
    },
  },
  watch: {
    selected_alphabet(val) {
      this.pagination.filters.alphabet = val
    },
    search() {
      this.getTransactiontype();
    },
    pagination: {
      handler: function () {
        this.getTransactiontype();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("submenu", ["setData"]),
    editRecord(trans_type_id) {
      this.trans_type_id = trans_type_id;
      this.edit_dialog=true;
      this.getTransactionDetails(trans_type_id)
    },
    deleteKeyword(keyword){
      this.keyword_loading = true;
      let _self = this
      axios.post("delete_keyword",keyword).then(response => {
        if(response.data.status){
          _self.edit_form_data.keywords = _self.edit_form_data.keywords.filter(function(eKeyword){
            return eKeyword.keyword_id != keyword.keyword_id
          })
        }
      }).catch(function(){
      }).then(function(){
        _self.keyword_loading = false;
      })
    },
    expandRow(itemData) {
      if(itemData.value) {
        this.items.data = this.items.data.map(function(item){
          if(item.user_id == itemData.item.user_id) {
            item.selected = true
          }
          return item
        })
      }
    },
    getTransactiontype() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("transaction_type_list?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
           _self.setData({key : 'alphabets',value : response.data.alphabets})
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    addTransactionType() {
      let _self = this;
      // this.loading = "accent";
      _self.form_loading = true;
      axios.post("add_transaction_types", _self.form_data)
        .then((response) => {
          _self.form_data = {income_expence:'1', profit_loss: true};
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false
            _self.getTransactiontype()
            //_self.items.data.push(data.data)
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    inlineUpdate(item) {
      axios.post("update_transaction_types", item)
      .then(() => {
      })
      .catch(function () {
      });
    },
    updateTransactiontype(){
      let _self = this;
      _self.edit_form_data.trans_type_id = _self.trans_type_id
      axios.post("update_transaction_types", _self.edit_form_data)
        .then((response) => {
          _self.edit_form_data = {profit_loss: true};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {profit_loss: true}
            _self.form_loading = false;
            _self.edit_dialog = false
            _self.getTransactiontype();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    getTransactionDetails(trans_type_id){
      let _self = this
      _self.form_loading= true;
      axios.get("get_transaction_type_details?trans_type_id="+trans_type_id)
        .then((response) => {
          _self.edit_form_data.title = response.data.data.title;
          _self.edit_form_data.income_expence = response.data.data.income_expence;
          _self.edit_form_data.acc_type_id = response.data.data.acc_type_id;
          _self.edit_form_data.bank_id = response.data.data.bank_id;
          _self.edit_form_data.keywords = response.data.data.keywords;
          _self.edit_form_data.profit_loss = response.data.data.profit_loss;
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    deleteTypes(){
      let _self = this
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.trans_type_id)
      })
      axios.post("delete_transaction_types",{
        ids : ids
      }).then(function(){
        _self.getTransactiontype()
      })
      .catch(function(){
        console.log('FAILURE!!');
      });
    },
    getAccountType() {
      let _self = this
      axios.get("account_type_list?itemsPerPage=-1")
        .then((response) => {
          _self.account_type_list = response.data.data.data;
        })
        .catch(function () {
          
        });
    },
    getBank() {
      let _self = this
      axios.get("account_list?itemsPerPage=-1")
        .then((response) => {
          _self.bank_list = response.data.data.data;
        })
        .catch(function () {
          
        });
    },
  },
  mounted() {
    this.getAccountType();
    this.getBank();
  },
};
</script>